<template>
  <!-- 상품 시간 정보 -->
  <div class="box">
    <admin-box-item
      title="상품 시간 정보">
      <div class="columns is-multiline">
        <!-- 상품 시간 정보 -->
        <div class="column is-full">
          <admin-form-item label="상품시간"
                           desc="행사, 이벤트, 쿠폰사용, 방문, 예약 가능 시간 혹은 기간으로 활용됩니다."
                           :notRequired="true">
            <div v-if="!prod.id" style="color:#ff5722;font-size:13px">상품 시간은 상품을 먼저 등록한 뒤 설정할 수 있습니다.</div>
            <div v-else-if="!operatingTime">상품 시간을 설정하려면 파트너를 먼저 선택해주세요.</div>
            <div v-else>
              <div class="lp-subtitle-block flex-align">구분
                <tool-tip style="margin-left:4px"
                          v-if="repeatPropArr.length===2"
                          icon="help_outline"
                          text="반복 일정 상품으로 변경시 1회 일정 상품으로 다시 변경할 수 없습니다."></tool-tip></div>
              <lp-radio :val.sync="repeat_prop"
                        value_name="value"
                        label_name="label"
                        @onSelect="selectRepeatProp"
                        :data="repeatPropArr"></lp-radio>

              <!-- 1회 일정 상품 -->
              <div v-if="repeat_prop === 0 && prod.package!=='meet'">
                <div class="lp-subtitle-block">날짜*</div>
                <admin-date-picker type="date" placeholderDate="시작 날짜 선택"
                                   @setDate="setStartDate"
                                   :not_before="moment().format('YYYY-MM-DD')"
                                   :data="start_date"></admin-date-picker>
                <div v-if="!is_closed && selectedPack!=='booking'">
                  <div class="lp-subtitle-block flex-align">
                    <div style="margin-right:16px">시작 시간 / 종료 시간*</div>
                    <lp-check-bool label="종일 예약" @onCheck="onCheckAllTime"
                                   :checkedVal.sync="all_time">
                    </lp-check-bool>
                  </div>
                  <div class="flex">
                    <time-range-picker :start="day_start" :end="day_end" :disabled="all_time"
                                       :usingRange="usingRange" :disableRange="disableRange"
                                       @setStart="setStart" @setEnd="setEnd"
                                       :start_time.sync="start_time" :end_time.sync="end_time" :unit="10"/>
                  </div>
                </div>

                <div class="lp-subtitle-block flex-align">
                  <div style="margin-right:16px">재고</div>
                </div>
                <div class="flex flex-align">
                  <div style="margin-right:20px">
                    <input type="number" v-model="stock" min="0" v-if="!stock_infinite">
                    <input type="number" v-else :disabled="true">
                  </div>
                  <lp-check-bool :checkedVal.sync="stock_infinite" label="무한대"/>
                </div>

                <!--<button class="button is-primary" style="margin-top:12px;width:200px" @click="saveTime(true)">1회 일정 상품 저장</button>-->
              </div>

              <!-- 반복 일정 상품 -->
              <schedule-calendar ref="calendar" v-else-if="repeat_prop===1"
                                 :selectedPack="selectedPack" :operatingTime="operatingTime"/>
            </div>
          </admin-form-item>
        </div>
      </div>
    </admin-box-item>
  </div>
</template>

<script>
  import LpAddress from "../../../module/common/LpAddress";
  import LpRadio from "../../../module/common/LpRadio";
  import AdminTimePicker from "../../../module/admin/AdminTimePicker";
  import ScheduleCalendar from "./ScheduleCalendar";
  import TimePicker from "../../../module/common/TimePicker";
  import TimeRangePicker from "../../../module/common/timeRangePicker";
  import moment from 'moment';
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import ToolTip from "../../../module/common/ToolTip";
  export default {
    name: "PanelProductTime",
    components: {
      ToolTip,
      LpCheckBool,
      TimeRangePicker,
      TimePicker,
      ScheduleCalendar,
      AdminTimePicker,
      LpRadio,
      LpAddress
    },
    props: {
      prod: {
        type: Object,
        required: false
      },
      prod_schedule: {
        type: Object,
        required: false
      },
      selectedPack: {
        type: String
      },
      operatingTime: {
        type: Array
      }
    },
    data() {
      return {
        repeatPropArr: [],
        repeat_prop: 0,
        org_start_date: '', // 시작날짜
        start_date: '',    // 시작날짜
        start_time: '',    // 시작시간
        end_time: '',       // 종료시간
        all_time: false,    // 하루종일

        day_start: {
          hour: 0,
          min: 0
        },
        day_end: {
          hour: 23,
          min: 55
        },
        usingRange: false,
        disableRange: undefined,
        is_closed: false,
        schedule_id: 0,
        stock: 0,
        stock_infinite: false
      }
    },

    created() {
      if(this.selectedPack === 'booking') {
        this.all_time = true;
      }

      if(this.$route.query.id) {
        this.getRepeatProp();
      }
    },

    watch: {
      prod() {
        this.initRepeatPropArr();
      },
      start_date(n) {
        if(!this.operatingTime) return;


        let day = moment(n).day() - 1;
        let time = null;
        // 일요일
        if(day === -1) {
          time = this.operatingTime[6];
        } else {
          time = this.operatingTime[day];
        }

        this.is_closed = time.is_closed;

        // 휴무일인 경우
        if(time.is_closed) {
          this.toast('선택한 날짜는 휴무일입니다.');
          return;
        }

        if(time.open_start) {
          this.day_start = this.timeToObject(time.open_start);
          this.day_end = this.timeToObject(time.open_end);
        } else {
          this.day_start = this.timeToObject('00:00');
          this.day_end = this.timeToObject('23:59');
        }

        // 브레이크 타임 설정되어있는 경우
        if(time.break_start) {
          this.usingRange = true;
          this.disableRange = {
            start: this.timeToObject(time.break_start),
            end: this.timeToObject(time.break_end)
          };
        } else {
          this.usingRange = false;
        }
      }
    },
    methods: {
      // 하루종일 체크
      onCheckAllTime() {
        // this.saveTime();
      },
      setStartDate(res) {
        this.start_date = res;
        if(this.org_start_date==='') {
          this.org_start_date = this.start_date;
        }
        // this.saveTime();
      },
      setStart(res) {
        this.start_time = res;
        // this.saveTime();
      },
      setEnd(res) {
        this.end_time = res;
        // this.saveTime();
      },
      async selectRepeatProp (res) {
        this.repeat_prop = res;
        await this.saveRepeatProp();
        this.prod.repeat_prop = res;
        this.getRepeatProp();
      },
      saveRepeatProp () {
        return this.$axios.post(this.getUrl(`product/${this.$route.query.id}/schedule/repeat_prop`), {
          repeat_prop: this.repeat_prop
        });
      },
      initRepeatPropArr() {
        this.repeat_prop = this.prod.repeat_prop;
        if(!this.$route.query.id) {
          this.repeatPropArr = [{label: '1회 일정 상품', value: 0},{label: '반복 일정 상품', value: 1}];
        } else if(this.prod.repeat_prop===0) {
          this.repeatPropArr = [{label: '1회 일정 상품', value: 0},{label: '반복 일정 상품', value: 1}];
        } else {
          this.repeatPropArr = [{label: '반복 일정 상품', value: 1}];
        }
      },
      getRepeatProp () {
        if(this.$store.getters.mode==='supervisor') return;
        // 반복 조건 가져오기
        this.$axios.get(this.getUrl(`product/${this.$route.query.id}/schedule/repeat_prop`)).then(res => {
          this.repeat_prop = res.data.repeat_prop;
          // 1회 일정 상품
          if(this.repeat_prop === 0 && res.data.schedule) {
            this.schedule_id = res.data.id;
            this.start_date = res.data.schedule.start_date;
            this.org_start_date = this.start_date;
            this.start_time = res.data.schedule.start_time;
            this.end_time = res.data.schedule.end_time;
            this.all_time = res.data.schedule.all_time;
            this.stock = res.data.schedule.stock;
            this.stock_infinite = res.data.schedule.stock_infinite;
          }

          if(this.selectedPack === 'booking') {
            this.all_time = true;
          }
        });
      },
      async saveTime() {
        if(this.prod.repeat_prop===1) return;
        if(this.start_date!=='') {
          if(!this.all_time) {
            // 시작시간이 종료시간보다 크게 입력했을 때 예외처리
            let start = parseInt(this.start_time.replace(':',''));
            let end = parseInt(this.end_time.replace(':',''));
            if(start>end) {
              return;
            }
          }

          let dates = {
            org_start_date: this.org_start_date,
            start_date: this.start_date,
            start_time: this.start_time,
            end_time: this.end_time,
            all_time: this.all_time,
            stock: this.stock,
            stock_infinite: this.stock_infinite
          };
          if(this.schedule_id === 0) {
            await this.$axios.post(this.getUrl(`product/${this.$route.query.id}/schedule`), dates).then(res=>{
              this.schedule_id = 1;
              // if(bool) this.toast('1회 일정 상품이 저장되었습니다.')
            });
          } else {
            await this.$axios.patch(this.getUrl(`product/${this.$route.query.id}/schedule/modify`), dates).then(res=>{
              this.org_start_date = this.start_date;
              // if(bool) this.toast('1회 일정 상품이 저장되었습니다.')
            });
          }

        }
      },
      timeToObject(time) {
        let result = {
          hour: 0,
          min: 0
        };
        if(time.indexOf(':')>-1) {
          let times = time.split(':');
          result.hour = parseInt(times[0]);
          result.min = parseInt(times[1]);
        }
        return result;
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .lp-subtitle-block
    margin 12px 0 8px 0
    font-size 13px
</style>
